exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GuidePageViewer-64adccac figure{margin:0}\n", ""]);

// Exports
exports.locals = {
	"GuidePageViewer": "GuidePageViewer-64adccac"
};